import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const HOTEL_EXTERIOR =
  "https://customer-assets.emergentagent.com/job_real-estate-varna/artifacts/wg2leajn_Screenshot%202026-07-15%20at%2012.15.03.png";
const HOTEL_LOGO =
  "https://customer-assets.emergentagent.com/job_real-estate-varna/artifacts/b4pbnwqj_Screenshot%202026-07-15%20at%2012.14.43.png";

export default function Location() {
  return (
    <section
      id="location"
      data-testid="location-section"
      className="relative bg-[#0B1F3D] text-[#F5EBD9] py-24 sm:py-32 lg:py-40 overflow-hidden"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
          className="mb-14 lg:mb-20 flex flex-col md:flex-row md:items-end md:justify-between gap-8"
        >
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#F5892E]" />
              <span className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#F5EBD9]/70">
                Локация · Хотел Черно Море
              </span>
            </div>
            <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[1.02] max-w-[20ch]">
              Легендарна локация в{" "}
              <span className="text-[#F5892E]">сърцето на Варна.</span>
            </h2>
          </div>
          <div className="md:max-w-sm">
            <p className="text-lg text-[#F5EBD9]/75 leading-relaxed">
              Хотел Черно Море — иконичен адрес на Варна, точно на бул. Сливница, на две
              крачки от Морската градина и центъра.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 1, ease: [0.2, 0.8, 0.2, 1] }}
          className="relative spotlight frame-shadow overflow-hidden aspect-[16/9] sm:aspect-[16/8]"
          data-testid="location-image"
        >
          <img
            src={HOTEL_EXTERIOR}
            alt="Хотел Черно Море, Варна"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#050d1e]/85 via-[#050d1e]/20 to-transparent" />

          {/* Hotel logo card */}
          <div className="absolute top-6 left-6 sm:top-8 sm:left-8 bg-white p-4 sm:p-5 shadow-2xl">
            <img
              src={HOTEL_LOGO}
              alt="Cherno More Hotel"
              className="h-12 sm:h-14 w-auto object-contain"
            />
          </div>

          {/* Bottom info */}
          <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-10">
            <div className="grid grid-cols-12 gap-4 items-end">
              <div className="col-span-12 sm:col-span-8">
                <div className="font-mono text-[10px] uppercase tracking-[0.32em] text-[#F5892E] mb-3">
                  Мястото на събитието
                </div>
                <div className="font-display uppercase text-2xl sm:text-3xl lg:text-4xl leading-[1.05]">
                  Хотел Черно Море · Варна
                </div>
              </div>
              <div className="col-span-12 sm:col-span-4 sm:text-right">
                <div className="inline-flex items-center gap-2 text-sm text-[#F5EBD9]/85">
                  <MapPin className="w-4 h-4 text-[#F5892E]" strokeWidth={2} />
                  <span className="font-mono uppercase tracking-widest text-[11px]">
                    бул. Сливница 33, Варна
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-10">
          {[
            { l: "Централна локация", d: "В сърцето на града" },
            { l: "На 400м от плажа", d: "Морската градина до теб" },
            { l: "Луксозна зала", d: "500+ капацитет" },
            { l: "Лесен достъп", d: "Паркинг · транспорт" },
          ].map((it, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
              className="border-t border-[#F5EBD9]/15 pt-5"
            >
              <div className="font-display uppercase text-lg sm:text-xl text-[#F5EBD9]">
                {it.l}
              </div>
              <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.28em] text-[#F5EBD9]/60">
                {it.d}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
